import React, { useState, useEffect, useRef } from 'react';

export const MySavedDataContext = React.createContext(
    {
        mySavedData: {},
        setMySavedData: () => { },
        saveData: () => { },
        loadData: () => { },
        clearSavedData: () => { },
        testing: ''
    }
);


//global application Context wrapper

export const MySavedDataContextProvider = (props) => {

    //Simple Date system
    const timeElapsed = Date.now();
    const currentTime = new Date(timeElapsed);

    const isInitialLoad = useRef(true); //keeping track on the initial autoload

    //Im cosidering moving state manipulation to same level of the context, and pass as HANDLER as props down...
    // const addPokemonToSaveData = (pokemonID) => {
    //     setMySavedData((previousState)=>(saveData));
    // }

    // const removePokemonFromSaveData = (pokemonID) => {
    //     setMySavedData((previousState)=>(saveData));
    // }


    //Application state (simple, without redux)
    const [mySavedData, setMySavedData] = useState(
        {
            pokemonList: [
                // { 
                //   name: 'charizard', 
                //   nickname: 'Tokek',
                //   id: 6,
                //   ownedPokemonUUID: 1
                // },
                // { 
                //   name: 'bulbasaur', 
                //   nickname: 'udang',
                //   id: 1,
                //   ownedPokemonUUID: 2
                // }
            ],
            lastUpdated: currentTime,
            highestOwnedPokemonUUID: 0
        }
    ); //empty state

    const saveData = (paramMySavedData) => {
        localStorage.setItem('myLocalStorageSavedData', JSON.stringify(paramMySavedData));

        // console.log('SAVED DATA from MySavedData state -> localStorage');

        // console.log('===Showing saved localStorage data:');
        // console.log(JSON.parse(localStorage.getItem("myLocalStorageSavedData")));

        // console.log('--');

        // can use sessionStorage. instead, if want to retain data only for that particular sessions...
    }

    const loadData = () => {
        //Load storage to State
        setMySavedData(JSON.parse(localStorage.getItem("myLocalStorageSavedData")));
        // console.log('DATA Loaded from localStorage -> state');
    }

    const clearSavedData = () => {
        localStorage.clear();

        // console.log('You just cleared your save data.. it should be clear like this:');
        // console.log(JSON.parse(localStorage.getItem("myLocalStorageSavedData")));
    }


    //My SavedData Effect
    useEffect(() => { // must check if it initial load or not
        if (isInitialLoad.current) {
            // console.log('initial load executing...');

            // execute autoload sequences:
            if (localStorage.getItem("myLocalStorageSavedData") !== null) { //watch out for SSR trying to check localstorage...
                //save data found, autoloading...
                // console.log('SAVE DATA FOUND, autoloading');
                loadData();
                // console.log('autoloading save data to state....');
            } else {
                //no save data exist yet...
                // console.log('NO SAVE DATA FOUND...');
                // console.log(localStorage.getItem("myLocalStorageSavedData"));
            }

            isInitialLoad.current = false; //done
        } else {
            saveData(mySavedData);
            // console.log('[Save data Effect] Executed autosave');
        }
        //initial load will trigger saved data,... prevent it from saving...

        // console.log('------------------------mySavedData effect! state changed! status:');

        // console.log('Current mySavedData State: ');
        // console.log(mySavedData);

        // console.log('Current LOCAL STORAGE: ');
        // console.log(localStorage.getItem("myLocalStorageSavedData"));
        // console.log('------------------------');

    }, [mySavedData]);


    return (
        <MySavedDataContext.Provider value={
            {
                mySavedData: mySavedData,
                setMySavedData: setMySavedData,
                saveData: saveData,
                loadData: loadData,
                clearSavedData: clearSavedData,
                currentTime: currentTime
            }
        }>
            {props.children}

        </MySavedDataContext.Provider>
    )


}

export default MySavedDataContext;